import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const HelpIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 12C21 16.9705 16.9705 21 12 21C7.02943 21 3 16.9705 3 12C3 7.02943 7.02943 3 12 3C16.9705 3 21 7.02943 21 12ZM12.9 8.4C12.9 8.89705 12.4971 9.3 12 9.3C11.5029 9.3 11.1 8.89705 11.1 8.4C11.1 7.90295 11.5029 7.5 12 7.5C12.4971 7.5 12.9 7.90295 12.9 8.4ZM12 10.2C11.5029 10.2 11.1 10.6029 11.1 11.1V15.6C11.1 16.0971 11.5029 16.5 12 16.5C12.4971 16.5 12.9 16.0971 12.9 15.6V11.1C12.9 10.6029 12.4971 10.2 12 10.2Z"
        fill="currentColor"
      />
    </svg>
  )
})

HelpIcon.displayName = 'HelpIcon'
